import type { ApiHook } from 'utils/request/useApi';

export type ListUsersResponse = {
  data: {
    id: string;
    username: string;
  }[];
};

export function getUsers(api: ApiHook) {
  return api.request<ListUsersResponse>({
    url: 'tables/users',
    method: 'POST',
    data: {
      columns: ['id', 'username'],
    },
  });
}
